<template lang="pug">
.task-form.columns
  b-loading(:active="isLoading")

  .column.is-8: .box
    b-field(label="Тема*", :type="errors && errors.title ? 'is-danger' : ''", :message="errors.title")
      b-input(v-model="value.title")

    b-field(label="Сообщение*", :type="errors && errors.body ? 'is-danger' : ''", :message="errors.body")
      b-input(v-model="value.body", type="textarea", rows="10")

  .column.is-4
    .box.has-background-light
      select-platform(
        v-if="canSelectPlatform",
        label="Платформа",
        v-model="value.platform_id",
        :data.sync="value.platform"
      )

      select-task-status(
        v-if="user.isSupport",
        label="Статус",
        v-model="value.status_id",
        :data.sync="value.status",
        @onLoadState="onLoadStatuses"
      )

      select-label(
        label="Тип",
        type="task",
        v-model="value.label_id",
        :data.sync="value.label"
      )

      b-field.select-label(v-if="user.isSupport", label="Метки")
        b-taginput(v-model="value.tags", :data="filteredTags", ref="taginput", :allow-new="false", autocomplete, icon="label" placeholder="Добавить", @typing="getFilteredTags")
          template(slot-scope="props")
            | {{ props.option.name }}
          template(#empty)
            | Метки не найдены
          template(#selected="props")
            b-tag(v-for="(tag, index) in props.tags", :key="index", rounded, :type="getType(tag)", :tabstop="false", ellipsis, closable, @close="$refs.taginput.removeTag(index, $event)")
              | {{ tag.name }}

      select-executor(
        v-if="user.isSupport",
        label="Исполнитель",
        v-model="value.executor_id",
        :data.sync="value.executor"
        with-reset
      )

      b-field(v-if="user.isAdmin", label="Дедлайн")
        b-datepicker(v-model="value.deadline_at", placeholder="Дедлайн", icon="calendar-today")

      b-field(v-if="user.isAdmin", label="Отслеживать в разделе «Задачи»")
        b-select(v-model="value.is_team")
          option(value="1")
            | Да
          option(value="0")
            | Нет

      b-field(label="Прикрепленные изображения или файлы")
        ui-upload(v-model="files", multiple, drag-drop)

    .box.has-background-warning(v-if="user.isAdmin")
      b-field(label="Заметки техподдержки")
        b-input(v-model="value.support_comment", type="textarea", rows="10")

</template>

<script>
import TaskFile from '@/models/TaskFile';
import Tag from '@/models/Tag';
import { mapGetters } from 'vuex';
import BSelect from 'buefy/src/components/select/Select';

export default {
  name: 'task-form',
  components: { BSelect },
  props: {
    value: Object,
    errors: Object,
  },

  data: () => ({
    isLoading: true,
    label: null,
    files: [],
    tags: Tag.collection(),
    filteredTags: [],
  }),

  computed: {
    ...mapGetters(['user']),
    canSelectPlatform() {
      return this.user.isSupport && (!this.value.platform || this.value.platform.status === 2);
    },
  },

  methods: {
    afterSave() {
      if (!this.value.files) {
        this.value.files = TaskFile.collection();
      }
      this.files.forEach(file => {
        TaskFile.makeFromFile(file, { task_id: this.value.id })
          .$save()
          .then(({ data }) => {
            this.value.files.add(data);
          });
      });
    },

    onLoadStatuses(statuses) {
      if (this.value.$isNew) {
        this.value.status_id = statuses.find('type', 'new').id;
      }
    },

    getFilteredTags(text) {
      let tags = this.tags;

      if (this.value.tags) {
        tags = this.tags.items.filter((option) => {
          for (let tag of this.value.tags) {
            if (tag.id === option.id) {
              return false;
            }
          }
          return true;
        });
      }

      this.filteredTags = tags.filter((option) => {
        return option.name
          .toString()
          .toLowerCase()
          .indexOf(text.toLowerCase()) >= 0;
      })
    },

    getType(tag) {
      return tag.color;
    }
  },

  created() {
    this.isLoading = false;
    this.tags.$fetch({
      sort: 'name',
      scope: 'active',
    });
  },
};
</script>

<style scoped>
.task-form {
  position: relative;
}
</style>
